import React, { createContext, useReducer, useContext } from "react";
import {
  GlobalState,
  GlobalAction,
  ActionTypes,
  GlobalContextProps,
} from "./models";

export const initialState = {} as GlobalState;

const Context = createContext({} as GlobalContextProps);

const reducer = (state = initialState, action: GlobalAction): GlobalState => {
  switch (action.type) {
    case ActionTypes.SET_CUSTOMER: {
      return { ...state, customer: action.payload };
    }
    case ActionTypes.SET_ORIGIN: {
      return { ...state, origin: action.payload };
    }
    case ActionTypes.SET_CHANNEL: {
      return { ...state, channel: action.payload };
    }
    case ActionTypes.SET_POINT_OF_SALE: {
      return { ...state, pointOfSale: action.payload };
    }
    case ActionTypes.SET_INITIAL_DATA: {
      return { ...state, initialData: action.payload };
    }
    case ActionTypes.SET_NOT_ASSOCIATED: {
      return { ...state, notAssociated: action.payload };
    }
    case ActionTypes.SET_SIMULATION: {
      return { ...state, simulation: action.payload };
    }
    case ActionTypes.SET_COMPLEMENTARY_DATA: {
      return { ...state, complementaryData: action.payload };
    }
    case ActionTypes.SET_SPOUSE: {
      return { ...state, spouse: action.payload };
    }
    case ActionTypes.SET_DPS: {
      return { ...state, DPS: action.payload };
    }
    case ActionTypes.SET_CONJUGE_DPS_ANSWERS: {
      return { ...state, conjugeDPSAnswers: action.payload };
    }
    case ActionTypes.SET_HOLDER_DPS_ANSWERS: {
      return { ...state, holderDPSAnswers: action.payload };
    }
    case ActionTypes.SET_DPS_STATUS: {
      return { ...state, DPSStatus: action.payload };
    }
    case ActionTypes.SET_PAYMENT: {
      return { ...state, payment: action.payload };
    }
    case ActionTypes.SET_BENEFICIARY: {
      return { ...state, beneficiaries: action.payload };
    }
    case ActionTypes.SET_CHANGE_BENEFICIARIES: {
      return { ...state, changeBeneficiaries: action.payload };
    }
    case ActionTypes.SET_PROPOSAL: {
      return { ...state, proposal: action.payload };
    }
    case ActionTypes.SET_CANCELLATION: {
      return { ...state, cancellation: action.payload };
    }
    case ActionTypes.SET_PLAN: {
      return { ...state, plan: action.payload };
    }
    case ActionTypes.SET_JOINT_ACCOUNT: {
      return { ...state, jointAccount: action.payload };
    }
    case ActionTypes.SET_CUSTOMER_DATA: {
      return { ...state, customerData: action.payload };
    }
    case ActionTypes.SET_GEOLOCATION: {
      return { ...state, geolocation: action.payload };
    }
    case ActionTypes.SET_MODALITY: {
      return { ...state, modality: action.payload };
    }
    case ActionTypes.SET_CONTRACTED_INSURANCE_SINGLE: {
      return { ...state, contractedInsuranceSingle: action.payload };
    }
    case ActionTypes.SET_CONTRACTED_INSURANCE_MULTIPLE: {
      return { ...state, contractedInsuranceMultiple: action.payload };
    }
    case ActionTypes.SET_PDF: {
      return { ...state, pdf: action.payload };
    }
    case ActionTypes.SET_CANCEL: {
      return { ...state, cancel: action.payload };
    }
    default: {
      throw new Error(`Unsupported action type: ${action}`);
    }
  }
};

type InitialState = {
  globalState?: GlobalState;
};

export const GlobalContextProvider: React.FunctionComponent<InitialState> = ({
  children,
  globalState = initialState,
}: any) => {
  const [state, dispatch] = useReducer(reducer, globalState);
  const value = { state, dispatch } as GlobalContextProps;
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export function GlobalContext() {
  const { state, dispatch } = useContext(Context);
  return { state, dispatch, ActionTypes };
}
